import { signIn, confirmSignIn, signOut } from "aws-amplify/auth";

interface ISignIn {
  nextStep: { signInStep: string; additionalInfo: { message: string } };
}

/**
 * Sign in the user with phone number
 */
export const signInWithPhoneNumber = async (
  info: any
): Promise<{
  nextStep: { signInStep: string; additionalInfo: { message: string } };
}> => {
  const appName = await localStorage.getItem('appname');
  const result = await signIn({
    username: `+91${info.phoneNumber}::${appName}::${info.customerId}`,
    options: {
      authFlowType: "CUSTOM_WITHOUT_SRP",
      preferredChallenge: "SMS_OTP",
    },
  });
  let message = "";
  if (
    String(
      (result as unknown as ISignIn)?.nextStep?.additionalInfo?.message
    ).toUpperCase() == "USER NOT REGISTERED"
  ) {
    message = "USER_NOT_REGISTERED";
  } else {
    message = "CONFIRM_SIGN_IN_WITH_SMS_CODE";
  }
  return {
    nextStep: { signInStep: message, additionalInfo: { message: "" } },
  };
};

/**
 * Confirm sign in with OTP
 */
export const confirmSignInWithOTP = async (otp: string): Promise<void> => {
  try {
    await confirmSignIn({ challengeResponse: otp });
    console.log("User signed in with OTP.");
  } catch (error) {
    console.error("Error confirming sign in with OTP:", error);
  }
};

/**
 * Sign out the user
 */
export const amazonSignOut = async (): Promise<void> => {
  try {
    await signOut();
    console.log("User signed out.");
  } catch (error) {
    console.error("Error signing out:", error);
  }
};
